import { useEffect, useState } from "react";
import { ShieldStar, UserGear, DownloadSimple, Archive } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { useDialog } from "../components/Dialog";

const ROLES = ["TENANT", "OWNER", "MANAGER", "CHAIRPERSON", "ADMIN"];

export default function Admin() {
  const { notify } = useDialog();
  const [items, setItems] = useState([]);
  const [files, setFiles] = useState([]);
  async function load() {
    const u = await api.get("/api/admin/users"); setItems(u.data.items);
    try { const a = await api.get("/api/attendance/archive/list"); setFiles(a.data.items); } catch { setFiles([]); }
  }
  useEffect(() => { load(); }, []);

  async function update(id, patch) {
    await api.patch(`/api/admin/users/${id}`, patch); load();
  }

  async function downloadArchive(name) {
    try {
      const res = await api.get(`/api/attendance/archive/download/${name}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = name; document.body.appendChild(a); a.click();
      document.body.removeChild(a); URL.revokeObjectURL(url);
    } catch { notify({ title: "Download failed", message: "Could not download that file." }); }
  }

  return (
    <div className="space-y-4 font-sans" data-testid="admin-screen">
      <div>
        <p className="text-[11px] font-bold uppercase tracking-[0.32em] text-white/50">System</p>
        <h1 className="font-display text-3xl font-extrabold text-white">Users & Roles</h1>
      </div>

      <div className="card flex items-start gap-3 p-4">
        <ShieldStar size={20} weight="duotone" className="mt-0.5 shrink-0 text-neon-pink" />
        <p className="text-[12px] text-white/65">Administer accounts. Changes apply immediately and are audited server-side.</p>
      </div>

      <div className="space-y-2">
        {items.map((u) => (
          <div key={u.id} className="card p-4" data-testid={`admin-user-${u.id}`}>
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-gradient-to-br from-neon-cyan to-neon-lime font-display text-base font-extrabold text-black">{u.name[0]?.toUpperCase()}</div>
              <div className="min-w-0 flex-1">
                <p className="truncate font-display text-[15px] font-semibold text-white">{u.name}</p>
                <p className="text-[11px] text-white/55">{u.loginCode}{u.flatId ? ` · ${u.flatId}` : ""}{u.phone ? ` · +91 ${u.phone}` : ""}</p>
              </div>
              <UserGear size={18} weight="duotone" className="text-white/55" />
            </div>
            <div className="mt-3 grid grid-cols-2 gap-2">
              <select className="field !py-2 text-[13px]" value={u.role} onChange={(e) => update(u.id, { role: e.target.value })} data-testid={`admin-role-${u.id}`}>
                {ROLES.map((r) => <option key={r} value={r} className="bg-ink-800">{r}</option>)}
              </select>
              <select className="field !py-2 text-[13px]" value={u.status} onChange={(e) => update(u.id, { status: e.target.value })} data-testid={`admin-status-${u.id}`}>
                <option value="ACTIVE" className="bg-ink-800">Active</option>
                <option value="DISABLED" className="bg-ink-800">Disabled</option>
              </select>
            </div>
          </div>
        ))}
      </div>

      <div data-testid="archive-section">
        <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.22em] text-white/55"><Archive size={11} weight="fill" className="-mt-0.5 mr-1 inline" /> Attendance archive (45-day retention)</p>
        <div className="card divide-y divide-white/5 p-0">
          {files.length === 0 ? (
            <p className="p-4 text-[12px] text-white/45">No archived days yet. As records age past 45 days they'll appear here as downloadable JSONL files.</p>
          ) : files.map((f) => (
            <button key={f.name} onClick={() => downloadArchive(f.name)} data-testid={`archive-${f.name}`}
              className="flex w-full items-center gap-3 px-4 py-3 text-left hover:bg-white/[0.03]">
              <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/5 text-neon-cyan"><DownloadSimple size={18} weight="duotone" /></div>
              <div className="min-w-0 flex-1">
                <p className="truncate font-mono text-[13px] text-white">{f.name}</p>
                <p className="text-[10px] text-white/45">{(f.size / 1024).toFixed(1)} KB · modified {new Date(f.modified).toLocaleString()}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
